export default __webpack_public_path__ + "static/media/cover_large_05.0860ec9b.jpg";